import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthContextModel } from "./AuthContextModel";

@Injectable({ providedIn: "root" })
export class AuthService {
    public authContext: BehaviorSubject<AuthContextModel>;

    constructor(
        private http: HttpClient) {
        this.authContext = new BehaviorSubject<AuthContextModel>(null);
    }

    public setAuthContext(): void {
        this.getAuthContext()
            .subscribe(authContext => {
                this.authContext.next(authContext);
            });
    }

    private getAuthContext(): Observable<AuthContextModel> {
        return this.http
            .get("/api/auth/context")
            .pipe(map(response => response as AuthContextModel));
    }
}
